import {useEffect} from "react";
import {useSignal} from "@preact/signals-react";
import {postSubmit} from "@ui-seeker/utils";

import { WEBBACK_V2_API, GROUPED_BY } from "@constants";
import {commonFiltersValue, groupedBy, isLoadingCommonFilters, isSystemBusy} from "@signals";
import { elementsInLoading, catalogueAnalyzerTabSelected } from "../../@signals";


export default function useCatalogueAnalyzerNumProductsSiteChart() {

	const isLoading = useSignal(false)
	const data = useSignal([])
	const chartKeys = useSignal([])

	useEffect(() => {
		if (isLoadingCommonFilters.value) {
			isLoading.value = true
			data.value = []
			postSubmit(`${WEBBACK_V2_API}/catalogue/num-products-site`, { 
				...commonFiltersValue.value, groupedBy: catalogueAnalyzerTabSelected.value
			}).then(res => {
				data.value = res.chartData
				chartKeys.value = res.chartKeys
			})
			.catch(() => {
				isSystemBusy.value = true
				isLoadingCommonFilters.value = false
			}).finally(() => isLoading.value = false)
		}
	}, [isLoadingCommonFilters.value]);

	useEffect(() => {
		if (isLoading.value)
			elementsInLoading.value = [...elementsInLoading.value, 'NumProductsSiteChart']
		else{
			elementsInLoading.value = elementsInLoading.value.filter(item => item !== 'NumProductsSiteChart')
		}
	}, [isLoading.value])

	return {
		isLoading: isLoading.value,
		data: data.value,
		chartKeys: chartKeys.value,
		title: 'Top 10 ' + (catalogueAnalyzerTabSelected.value === GROUPED_BY.BRAND ? 'Brand' : 'Category') + ' Share by site',
	}
}